const ADMIN_SESSION_EXPIRED = "__adminSessionExpired";

let onSessionExpired = null;

export function setAdminSessionExpiredHandler(handler) {
  onSessionExpired = handler;
}

export function isAdminSessionExpiredError(error) {
  return Boolean(error?.[ADMIN_SESSION_EXPIRED]);
}

function isProtectedAdminRequest(config) {
  const url = String(config?.url || "");
  return url.includes("/admin/");
}

/** Utilisateur NCB avec rôle admin (téléchargement vidéo, suppression binôme). */
export function isNcbAdmin(user) {
  return String(user?.role || "").toLowerCase() === "admin";
}

/** @returns {boolean} true si la session admin a été invalidée */
export function handleAdminApiResponseError(error) {
  if (error?.response?.status !== 401 || !isProtectedAdminRequest(error.config)) {
    return false;
  }

  error[ADMIN_SESSION_EXPIRED] = true;

  try {
    if (onSessionExpired) {
      onSessionExpired();
    } else if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
      window.location.assign("/admin/login");
    }
  } catch (err) {
    console.warn("[admin] redirection session expirée impossible", err);
  }

  return true;
}
